var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useRef } from 'react';
import { SchemaMarkupForm } from '@formily/react-schema-renderer';
import { autoScrollInValidateFailed } from '../shared';
export var SchemaForm = function (props) {
    var formRef = useRef();
    return (React.createElement("div", { ref: formRef },
        React.createElement(SchemaMarkupForm, __assign({}, props, { onValidateFailed: function (result) {
                if (props.onValidateFailed) {
                    props.onValidateFailed(result);
                }
                autoScrollInValidateFailed(formRef);
            } }), props.children)));
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/antd/esm/components/SchemaForm.js
// module id = 5802
// module chunks = 0